import { render, staticRenderFns } from "./reviewer-part-one-page.component.vue?vue&type=template&id=3d63b90d"
import script from "./reviewer-part-one-page.component.ts?vue&type=script&lang=ts&external"
export * from "./reviewer-part-one-page.component.ts?vue&type=script&lang=ts&external"
import style0 from "./reviewer-part-one-page.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports